var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49765 8C5.49765 6.61799 6.61799 5.49766 7.99999 5.49766C9.382 5.49766 10.5023 6.61799 10.5023 8C10.5023 9.382 9.382 10.5023 7.99999 10.5023C6.61799 10.5023 5.49765 9.382 5.49765 8Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58477 0.17615C7.81177 -0.0587168 8.18822 -0.0587168 8.41522 0.17615L10.3958 2.22536H13.1972C13.5161 2.22536 13.7746 2.4839 13.7746 2.80283V5.60422L15.8238 7.58477C16.0587 7.81177 16.0587 8.18823 15.8238 8.41523L13.7746 10.3958V13.1972C13.7746 13.5161 13.5161 13.7746 13.1972 13.7746H10.3958L8.41522 15.8238C8.18822 16.0587 7.81177 16.0587 7.58477 15.8238L5.60421 13.7746H2.80283C2.4839 13.7746 2.22536 13.5161 2.22536 13.1972V10.3958L0.17615 8.41522C-0.0587164 8.18823 -0.0587169 7.81177 0.17615 7.58477L2.22536 5.60421V2.80283C2.22536 2.4839 2.4839 2.22536 2.80283 2.22536H5.60421L7.58477 0.17615ZM7.99999 4.34273C5.98014 4.34273 4.34272 5.98015 4.34272 8C4.34272 10.0199 5.98014 11.6573 7.99999 11.6573C10.0198 11.6573 11.6573 10.0199 11.6573 8C11.6573 5.98015 10.0198 4.34273 7.99999 4.34273Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/SettingsIcon.522c0e5bdee25db17c0ef3b8a9b755c0.svg";
export { ForwardRef as ReactComponent };